module.exports = __webpack_public_path__ + "static/img/4.815e505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/4.png
// module id = gtuN
// module chunks = 31